import { useEffect } from 'react';

/**
 * Set document.title for the page's lifetime (parity with the former Backbone
 * pages, which set a per-page <title> via Django templates). Restores the
 * previous title on unmount.
 */
export function useDocumentTitle(title: string) {
  useEffect(() => {
    const prev = document.title;
    document.title = title;
    return () => {
      document.title = prev;
    };
  }, [title]);
}
